import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { companyService } from "../../../../api/services/company";
import { publicService } from "../../../../api/services/public";
import { State } from "../../../../redux/store";
import {Auction, WinningParticipant} from "../../../../types/auction";
import { Company } from "../../../../types/company";
import digitsOnly from "../../../../utils/digitsOnly";
import { useSnack } from "../../../../utils/useSnack";
import { Response } from "../../../../types/api";
import { auctionService } from "../../../../api/services/auction";
import { useTranslation } from "react-i18next";

export default function Result({ 
  auctionId, auction, getAuction, participant
}: { 
  auctionId: number;
  auction: Auction | null;
  getAuction: () => void;
  participant: boolean;
}) {
  const { t } = useTranslation();
  const { snack } = useSnack();
  const state = useSelector((state: State) => state);
  const company: Company | null = state.company.company;

  async function downloadResultFile() {
    if (!company || !auction?.resultReportFileId) { return }

    try {
      let fileTokenResponse: Response<{ id: number }>;

      if (participant) {
        fileTokenResponse = await auctionService.getFileToken(auctionId, company.id, auction.resultReportFileId);
      }
      else { 
        fileTokenResponse = await companyService.getFileToken(company.id, auction.resultReportFileId); 
      }

      if (fileTokenResponse.status === "success" && fileTokenResponse.data) {
        publicService.downloadFile(
          fileTokenResponse.data.id, 
          `${t("docs.result_protocol")}.pdf`
        );
      }
      else { snack(t("snack.error.file_download"), "error") }
    }
    catch (error) {
      const err = error as AxiosError;
      snack(t("snack.error.file_download"), "error"); 
    }
  }

  return (
    <Box>
      <Grid container gap={7}>
        <Grid item xs={12}>
          <Typography variant="h5">
            {t("auction.result.winner")}
          </Typography>
          <Divider sx={{ mt: 1, mb: 2 }} />
          {auction?.winningParticipants?.map((participant: WinningParticipant, idx: number) => (
          <Grid container columnGap={7} rowGap={3} style={{paddingBottom: '15px'}} key={idx}>
            <Grid>
              <Typography>{t("auction.result.company_title")}</Typography>
              <Typography variant="h6">{participant?.ownerTitle ?? ""}</Typography>
            </Grid>
            <Grid>
              <Typography>{t("auction.result.company_title")}</Typography>
              <Typography variant="h6">{participant?.title ?? ""}</Typography>
            </Grid>

            <Grid>
              <Typography>{t("auction.result.company_itn")}</Typography>
              <Typography variant="h6">{digitsOnly(participant?.itn) ?? ""}</Typography>
            </Grid>
            
            <Grid>
              <Typography>{t("auction.result.ceo_name")}</Typography>
              <Typography variant="h6">{participant?.ceoName ?? ""}</Typography>
            </Grid>
          </Grid>
          ))}
        </Grid>
        
        <Grid>
          <Typography variant="h5">{t("auction.result.result_protocol")}</Typography>
          <Divider sx={{ mt: 1, mb: 2 }} />
          <Button onClick={downloadResultFile}>
            {t("auction.result.download_result_protocol")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}